import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import { useTranslation } from 'react-i18next';
import React from 'react';
import AllPartnersList from '@app/pages/customer/AllPartnersList/AllPartnersList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

const RoutesListPage = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t(`partners.TemplatesList`, `Partneři`)}>
      {/*
        // @ts-ignore*/}
      <Card>
        <AllPartnersList />
      </Card>
    </ResponsiveLayout>
  );
};
export default withAuthenticationRequired(RoutesListPage);
